import {
  errorNotifier,
  successNotifier,
} from "../../../components/NotificationHandler";
import http, { AUTH_ROUTES } from "../../../services/api";

export const unbanErrandBoy = async (payload) => {
  try {
    await http.put(
      AUTH_ROUTES.BAN_ERRAND_BOY(payload.userId, payload._id),
      payload
    );
    successNotifier("Errand boy Unbanned");
  } catch (e) {
    errorNotifier(e.response?.data?.result);
  }
};
